import { PayoutPreferences } from "@wingspanhq/payments/dist/interfaces";
import type { paymentsApiSpec } from "@wingspanhq/wingspan-api-types";

type PayoutResponse =
  paymentsApiSpec.operations["getPayouts"]["responses"]["200"]["content"]["application/json"][number];

type PayoutOverrides = {
  payoutId: string;
  currency: paymentsApiSpec.CurrencyCode;
  payoutItems?: IPayoutItem[];
  clearingItems?: IPayoutItem[];
  futureDebitItems?: IPayoutItem[];
};

export type IPayoutResponse = Omit<PayoutResponse, keyof PayoutOverrides> &
  PayoutOverrides;

export type IPayoutListResponse = IPayoutResponse[];

export type IPayoutItem = paymentsApiSpec.PayoutItem & {
  sourceSubType?: string;
};

export enum PayoutStatusEnum {
  Created = "Created",
  Clearing = "Clearing",
  Failed = "Failed",
  Complete = "Complete"
}

export const PayoutTypeEnum = {
  PayoutType_Instant: "Instant" as PayoutPreferences,
  PayoutType_Standard: "Standard" as PayoutPreferences
};
